export default __webpack_public_path__ + "02188894d5236b1517df3210b79c2a7f.svg";